export var ViewPopupBackdropType;
(function (ViewPopupBackdropType) {
    ViewPopupBackdropType[ViewPopupBackdropType["Shadow"] = 0] = "Shadow";
    ViewPopupBackdropType[ViewPopupBackdropType["Mask"] = 1] = "Mask";
})(ViewPopupBackdropType || (ViewPopupBackdropType = {}));
